<template>
  <div>
    <QueryFrame
      :addText="handlePermission('curingResultAdd') ?'创建养护记录':''"
      :count="count"
      :current="page"
      @addNew="addCuringResult"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>养护规则:</label>
          <lk-select class="item" clearable filterable placeholder="全部" v-model.trim="query.curingRuleId">
            <lk-option :key="item.id" :value="item.id" v-for="item in curingRuleList">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>养护标准:</label>
          <lk-select class="item" clearable placeholder="全部" v-model.trim="query.standard">
            <lk-option :key="index" :value="item[0]" v-for="(item, index) in standardsMap">
              {{item[1]}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>下次养护时间小于:</label>
          <lk-select class="item" clearable placeholder="全部" v-model.trim="query.alertDays">
            <lk-option :key="item" :value="item" v-for="item in 10">
              {{item}}天
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>来源:</label>
          <lk-select class="item" v-model="query.purchaseType" clearable>
            <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button @click="handleSearch(true, resetGoods)" class="mr" type="primary">查询</lk-button>
          <lk-button @click="handleReset" class="mr">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <!--<p><lk-checkbox class="mb8" @on-change="handleSelectAllResult">选择所有搜索结果</lk-checkbox></p>-->
        <lk-table
          :columns="columns"
          :data="tableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel"
          border>
        </lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'curing',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    selectedTempGoodsIds() { // 临时选中的明细
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
  },
  data() {
    return {
      curingRuleList: [],
      standardsMap: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      statusMap: new Map([
        [1, '正常'],
        [2, '异常'],
      ]),
      query: {
        storeIdList: [],
        goodsName: null,
        approvedDrugNames: null,
        curingRuleId: null,
        standard: null,
        mnemonicCode: null,
        alertDays: null,
        type: null, // 商品类型
        purchaseType: null, // 来源
      },
      columns: [
        { type: 'selection', width: 60 },
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '助记码', key: 'mnemonicCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        {
          title: '生产厂家',
          key: 'manufacturer',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '上市许可持有人',
          minWidth: 120,
          tooltip: true,
          key: 'inventoryInfoMah',
        },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '数量', key: 'curingCount', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        { title: '养护标准', key: 'standardStr', minWidth: 110 },
        { title: '养护人员', key: 'curingUserName', minWidth: 110 },
        { title: '养护规则', key: 'curingRuleName', minWidth: 110 },
        { title: '上次养护时间', key: 'curingTime', minWidth: 130 },
        {
          title: '下次养护时间',
          key: 'nextTime',
          minWidth: 130,
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          minWidth: 176,
          tooltip: true,
        },
        {
          title: '来源',
          key: 'purchaseTypeName',
          minWidth: 176,
          tooltip: true,
        },
      ],
      tableData: [],
      tempGoods: [],
    };
  },
  methods: {
    addCuringResult() {
      if (this.tempGoods.length === 0) {
        this.$Message.error('请选择记录！');
        return;
      }

      const recordIds = [];
      const hasZero = [];
      this.tempGoods.forEach((data) => {
        if (data.curingCount === 0) {
          hasZero.push(`批号为${data.goodsBatchNumber}的商品${data.drugSerialCode}库存为0，无需养护`);
        } else {
          recordIds.push(data.id);
        }
      });
      if (hasZero.length > 0) {
        this.$Message.error(hasZero.join(';'));
      } else {
        // window.sessionStorage.setItem('curingRecordIds', recordIds); // 解决养护记录id通过params传递导致url超限
        this.$router.push({ name: 'curingResultAdd', params: { ids: recordIds.join(',') } });
      }
    },
    getCuringRuleList() {
      return inventory.curingRuleList({ status: 1 }).then((res) => {
        if (res.data.status === 200) {
          const { list } = res.data.data;
          this.curingRuleList = [];
          list.forEach((item) => {
            this.curingRuleList.push(item.curingRule);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData(isTransform, isAll) {
      return new Promise((resolve) => {
        this.params.page = this.page;
        this.params.size = this.size;
        isAll && delete this.params.page;
        isAll && delete this.params.size;
        inventory.curingList(this.params).then((res) => {
          if (res.data.status === 200) {
            const { count, list } = res.data.data;
            list.forEach((item) => {
              item.standardStr = this.standardsMap.get(item.curingStandard);
              item.curingResultStr = this.statusMap.get(item.curingResult);
              if (!item.curingTime) {
                item.curingTime = '-';
              } else {
                item.curingTime = utils.exchangeTime(item.curingTime);
              }
              if (!item.curingUserName) {
                item.curingUserName = '-';
              }
              item.nextTime = utils.exchangeTime(item.nextTime);

              // 已经选中的列表和临时选中的列表
              const isChecked = this.selectedTempGoodsIds.includes(item.id);
              item._checked = isChecked;
              if (isAll && !isChecked) {
                this.tempGoods.push(item);
              }
            });
            this.count = count;
            this.tableData = list;
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(row.id)) {
        this.tempGoods.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        if (item.id === row.id) {
          this.tempGoods.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.id)) {
          this.tempGoods.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      // 全部取消的时候，只能把当前选中的列表置空，但是在一选择的列表中无法区分出来，所以本处采用对当列表进行单个操作
      this.tableData.forEach((good) => {
        // 列表中已经存在 查找该项目在tempGoods中的位置并移除
        for (let i = 0, len = this.tempGoods.length; i < len; i++) {
          if (this.tempGoods[i].id === good.id) {
            this.tempGoods.splice(i, 1);
            break;
          }
        }
      });
    },
    // 选择所有搜索结果
    handleSelectAllResult(val) {
      if (val) {
        this.getData(false, val).then(() => {
          this.getData(false);
        });
      } else {
        this.tempGoods = [];
        this.getData(false);
      }
    },
    handleReset() {
      this.query = {};
    },
    resetGoods() {
      this.tempGoods = [];
    },
  },
  mounted() {
    this.getCuringRuleList();
    this.handleSearch(true, this.resetGoods);

    if (this.roleType !== 2) {
      this.columns.splice(2, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>

</style>
